export type MenuItem = {
  key: string;
  roles: Array<string>;
  config: MenuItemConfig;
};

export type MenuItemConfig = {
  name: string;
  icon: string;
  open: boolean;
  link: string;
};

export const MENU_CONFIG: Array<MenuItem> = [
  {
    key: 'homepage',
    roles: ['AuditReports'],
    config: {
      name: 'Homepage',
      icon: 'home',
      open: true,
      link: 'homepage',
    },
  },
  {
    key: 'carbon-credit',
    roles: ['CarbonCreditsIngestion'],
    config: {
      name: 'Carbon Credits',
      icon: 'eco',
      open: false,
      link: 'carbon-credit',
    },
  },
  {
    key: 'carbon-credit-validation',
    roles: ['CarbonCreditsValidation'],
    config: {
      name: 'Carbon Credits Validation',
      icon: 'pan_tool',
      open: false,
      link: 'carbon-credit-validation',
    },
  },
  {
    key: 'carbon-function',
    roles: ['CarbonFootprintCalculationIngestion'],
    config: {
      name: 'Carbon Function',
      icon: 'functions',
      open: false,
      link: 'carbon-function',
    },
  },
  {
    key: 'carbon-function-validation',
    roles: ['CarbonFootprintCalculationValidation'],
    config: {
      name: 'Carbon Function Validation',
      icon: 'engineering',
      open: false,
      link: 'carbon-function-validation',
    },
  },
  {
    key: 'production-ddt-dashboard',
    roles: ['PowerBiAnalytics'],
    config: {
      name: 'Production & DDT Analytics',
      icon: 'analytics',
      open: false,
      link: 'production-ddt-dashboard',
    },
  }
];
